import React, { Component, Fragment } from 'react';
import { isEmpty, size } from 'lodash';
import axios from 'axios';
import IconButton from '@mui/material/IconButton';
import { AddCircleOutlineRounded, CloudDownloadRounded, MoreVertRounded } from '@mui/icons-material';

import { 
    Menu, 
    MenuItem,
    Button,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Box,
    Tabs,
    Tab,  
} from '@mui/material';

import Pagination from '../../../container/MUI/Pagination';
import UserForm from './UserForm';
import DeleteDialog from '../../common/DeleteDialog';
import Currency from '../../common/Currency';
import UserUpdate from './UserUpdate';
import UserUpdatePassword from './UserUpdatePassword';
import AccessTypeForm from './AccessTypeForm';
import TabsContent from '../../common/TabsContent';
import AccessList from './AccessList';
import UserCredits from './UserTabs/UserCredits';
import { SearchBarV2 } from '../../common/SearchBar';
import UserSingle from './UserSingle';

// Champ CSV : guillemets doublés, champ entouré de guillemets s'il contient , " ou saut de ligne
const csvField = (value) => {
    if (value === undefined || value === null) return ''
    if (typeof value === 'number') return Number.isFinite(value) ? String(value) : ''
    const str = String(value)
    return /[,"\r\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str
}

class UsersList extends Component {
    state = { 
        page: 0,
        rowsPerPage: 10,
        openForm: false,
        openAccessForm: false,
        anchorEl: null, 
        openMenu: "", 
        user: {},
        updatePassword: false,
        updateUser: false,
        updateUserFromSingle: false,
        singleUser: false, 
        tab: 0,

        searchUser: "",
        user_is_active: "",
    }

    handleChange = (e) => {
        this.setState({ searchUser: e.target.value });
    };
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        console.log("handle rows", event.target.value);
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        if(isEmpty(this.props.USERS)){
            this.props.fetchUsers()
        }
    }

    handleClose = () => {
		this.setState({ 
            openForm: false,
            openAccessForm: false,
        });
    };    

    handleSingleUser = (user) => {
		this.setState({
			user,
            singleUser: true,
            openMenu: "",
            anchorEl: null
		})
	}
    handleOpenUpdate = (user) => {
		this.setState({
			user,
            updateUser: true,
            openMenu: "",
            anchorEl: null
		})
	}
    handleOpenUpdateFromSingle = (user) => {
		this.setState({
			user,
            updateUserFromSingle: true,
            openMenu: "",
            anchorEl: null
		})
	}
    handleOpenUpdatePassword = (user) => {
		this.setState({
			user,
            updatePassword: true,
            openMenu: "",
            anchorEl: null
		})
	}

    handleDelete = async () => {
        const { toDelete } = this.state;
        await this.props.deleteUser(toDelete)
        if(this.props.STATE.users.error){
            // this.props.notif("error", "ERROR")
            this.props.notif("error", this.props.STATE.users.error)
        } else {

            this.props.notif("success", "Utilisateur supprimé")
            this.setState({
                deleteUser: false,
                toDelete: {},
            })
        }
    }

    handleResendConfirmation = async (user) => {
        this.setState({ openMenu: "", anchorEl: null });
        try {
            await axios.post("/email-confirmation/resend", { email: user.email });
            this.props.notif("success", "Email de confirmation renvoyé à " + user.email);
        } catch (err) {
            const status = err && err.response && err.response.status;
            if (status === 429) {
                this.props.notif("error", "Merci d'attendre avant un nouvel envoi");
            } else if (status === 404) {
                this.props.notif("error", "Aucun compte trouvé pour " + user.email);
            } else if (status === 400) {
                this.props.notif("error", "Compte déjà confirmé ou email invalide");
            } else {
                console.error("resend confirmation failed:", err);
                this.props.notif("error", "Erreur lors de l'envoi de l'email");
            }
        }
    }
   
    getFilteredList = () => {
        const { USERS } = this.props;
        const { searchUser } = this.state;
        let list = Object.values(USERS)
        // users
        // console.log('====================================');
        // console.log({searchUser});
        // console.log('====================================');
        if(!isEmpty(searchUser)){
            list = list.filter( user => (
                user.username.toLowerCase().includes(searchUser.toLowerCase()) ||
                user.email.toLowerCase().includes(searchUser.toLowerCase()) ||
                user.lastname.toLowerCase().includes(searchUser.toLowerCase())
            ))
        }
        return list
    }

    // Export CSV des comptes collaborateur (4711xxxx) : liste filtrée par la recherche courante
    // (toute la liste si la recherche est vide), non paginée. Les utilisateurs sans compte
    // collaborateur sont inclus (cellule vide) pour repérer les manquants.
    handleExportCSV = () => {
        const { USERS, EMPLOYEES } = this.props
        if (isEmpty(USERS)) return
        const lines = [['Compte collaborateur', 'Nom', 'Prénom', 'Email', 'Matricule', 'Statut', 'Actif']]
        this.getFilteredList().forEach(user => {
            const employee = (EMPLOYEES && user.user_employee_id && EMPLOYEES[user.user_employee_id]) || {}
            const statut = user.user_status === "DELETED" ? "SUPPRIMÉ"
                : user.user_status === "WAITING_ACTIVATION" ? "En attente confirmation"
                : user.user_status === "BLOCKED" ? "BLOCKED"
                : !user.user_is_active ? "DÉSACTIVÉ"
                : user.user_status
            lines.push([
                user.user_collab_account,
                user.lastname,
                user.username,
                user.email,
                employee.employee_matricule,
                statut,
                user.user_is_active ? 'oui' : 'non',
            ])
        })

        const csv = lines.map(line => line.map(csvField).join(',')).join('\n') + '\n'
        const day = new Date().toISOString().slice(0, 10)
        const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' }))
        const link = document.createElement('a')
        link.href = url
        link.download = `MJB_comptes_collaborateurs_${day}.csv`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
    }

    displayList = () => {
        const { USERS } = this.props;
        let tab = []
        let rows = 0
        if (!isEmpty(USERS)){
            let all = this.getFilteredList()            
            rows = size(all)
            // console.log('====================================');
            // console.log({all, rows});
            // console.log('====================================');
            tab.push(this.getUserList(all))
        }
        return {tab, rows}
    }


    getUserList = (list) => {
        const { USERS, isSuper } = this.props
        const { openMenu, anchorEl } = this.state;
        const roles = {1:"USER", 2:"ADMIN", 3:"SUPERADMIN", 4:"ADMIN +", 10:"USER +"}

        // if (!isEmpty(list)){
            return list.map(user =>  (
                <TableRow className="clickable" hover>
                    <TableCell onClick={() => this.handleSingleUser(user)}>{new Date(user.user_creation_date).toLocaleDateString("fr-FR") }</TableCell>
                    <TableCell onClick={() => this.handleSingleUser(user)}>{
                        user.user_status === "DELETED" ? "SUPPRIMÉ"
                        : user.user_status === "WAITING_ACTIVATION" ? "En attente confirmation"
                        : user.user_status === "BLOCKED" ? "BLOCKED"
                        : !user.user_is_active ? "DÉSACTIVÉ"
                        : user.user_status
                    }</TableCell>
                    <TableCell onClick={() => this.handleSingleUser(user)}>{user.email}</TableCell>
                    <TableCell onClick={() => this.handleSingleUser(user)}>{user.lastname}</TableCell>
                    <TableCell onClick={() => this.handleSingleUser(user)}>{user.username}</TableCell>
                    <TableCell onClick={() => this.handleSingleUser(user)}>{roles[user.user_role]}</TableCell>
                    <TableCell onClick={() => this.handleSingleUser(user)}>{<Currency value={user.account} />}</TableCell>
                    <TableCell onClick={() => this.handleSingleUser(user)}>{user.user_organization_name || "Non renseigné"}</TableCell>
                    <TableCell>
                    { 
                        isSuper && 
                        user.user_role !== 3 &&  
                        
                        <Fragment>
                            <IconButton 
                                aria-controls={`option-menu${user.user_id}`} 
                                aria-haspopup="true"
                                onClick={ event => this.setState({ 
                                    anchorEl: event.currentTarget, 
                                    openMenu : user.user_id
                                }) }
                            >
                                <MoreVertRounded fontSize="small" />
                            </IconButton>
                            <Menu
                                id={`option-menu${user.user_id}`}
                                anchorEl={anchorEl}
                                getContentAnchorEl={null}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={ openMenu === user.user_id }
                                onClose={() => this.setState({ openMenu: "", anchorEl: null})}
                            >   
                                <MenuItem 
                                    onClick={ () => this.handleOpenUpdate(user) } 
                                >
                                    Modifier
                                </MenuItem>
                                <MenuItem 
                                    onClick={ () => this.handleOpenUpdatePassword(user) } 
                                >
                                    Modifier le Mot de Passe
                                </MenuItem>
                            
                                { user.user_status === "WAITING_ACTIVATION" &&
                                    <MenuItem
                                        onClick={ () => this.handleResendConfirmation(user) }
                                    >
                                        Renvoyer l'email de confirmation
                                    </MenuItem>
                                }
                                { user.user_status === "WAITING_ACTIVATION" &&
                                    <MenuItem
                                        onClick={
                                            () => this.setState({
                                                deleteUser: true,
                                                toDelete: user,
                                                openMenu: "",
                                                anchorEl:null
                                            })
                                        }
                                    >
                                        Supprimer
                                    </MenuItem>
                                }
                            </Menu>
                        </Fragment>
                    }
                    </TableCell>
                </TableRow>
            ))
        // }
    }

    render() {
        const { isSuper, USERS } = this.props;
        const { singleUser, openForm, deleteUser, toDelete, updateUser, updateUserFromSingle, user, updatePassword, openAccessForm } = this.state;
        const { tab, rows } = this.displayList();
        return (
            <div>
                {openForm &&
                    <UserForm handleClose={this.handleClose} {...this.props} />
                }
                {openAccessForm &&
                    <AccessTypeForm handleClose={this.handleClose} {...this.props} />
                }
                {deleteUser && !isEmpty(toDelete) &&
                    <DeleteDialog
                        title={"l'utilisateur"}
                        open={true}
                        close={() => this.setState({ deleteUser: false, toDelete: {} })}
                        notif={this.props.notif}
                        handleSubmit={this.handleDelete}
                        // {...this.props}
                    />
                }
                {updateUser && user && 
                    <UserUpdate
                        open={true}
                        handleClose={() => this.setState({ updateUser: false, user: {} }) }
                        user={user}
                        {...this.props}
                    />
                }
                {updateUserFromSingle && user && 
                    <UserUpdate
                        open={true}
                        handleClose={() => this.setState({ updateUserFromSingle: false }) }
                        user={user}
                        {...this.props}
                    />
                }
                {updatePassword && user && 
                    <UserUpdatePassword
                        open={true}
                        handleClose={() => this.setState({ updatePassword: false, user: {} }) }
                        user={user}
                        {...this.props}
                    />
                }
                {singleUser && user && 
                    <UserSingle
                        open={true}
                        handleCloseAll={() => this.setState({ singleUser: false, user: {} }) }
                        user={user}
                        handleOpenUpdate={ () => this.handleOpenUpdateFromSingle(user) } 
                        {...this.props}
                    />
                    // <UserCredits
                    //     open={true}
                    //     handleClose={() => this.setState({ singleUser: false, user: {} }) }
                    //     user={user}
                    //     {...this.props}
                    // />
                }
                {isSuper &&
                    <Tabs
                        value={this.state.tab}
                        onChange={(e, tab) => this.setState({ tab })}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        scrollButtons="auto"
                        // variant="scrollable"
                    >
                        <Tab label="Utilisateurs" />
                        <Tab label="Accès" />
                    </Tabs>    
                }
                <Box p={1}>
                    {this.state.tab === 0 &&
                        <Box>
                             <Typography variant="h6" id="tableTitle">
                                Liste des Utilisateurs
                            </Typography>
                            {/* <Box style={{ display:"flex", justifyContent:"space-between", alignItems: "center"}}>
                                <SearchBar 
                                    handleChange={this.handleChange} 
                                    label="Rechercher un Utilisateur"
                                    searchValue={this.state.searchUser}
                                />
                                {isSuper &&
                                    <Box p={1} style={{textAlign: "right"}}>
                                        <Button variant="contained" 
                                            onClick={() => this.setState({openForm: true})} 
                                            color="secondary"
                                            title="Nouvel Utilisateur"
                                            startIcon={<AddCircleOutlineRounded />}
                                        >
                                            Ajouter
                                        </Button>
    
                                    </Box>
                                }
                            </Box> */}
                            <SearchBarV2
                                handleChange={this.handleChange} 
                                label="Rechercher un Utilisateur"
                                searchValue={this.state.searchUser}
                            >
                                <Button color="primary" startIcon={<CloudDownloadRounded />} onClick={this.handleExportCSV} title="Exporter les comptes collaborateur (liste filtrée)">
                                    Exporter CSV
                                </Button>
                                {isSuper &&
                                    <Button variant="contained" 
                                        onClick={() => this.setState({openForm: true})} 
                                        color="secondary"
                                        title="Nouvel Utilisateur"
                                        startIcon={<AddCircleOutlineRounded />}
                                    >
                                        Ajouter
                                    </Button>
                                }
                            </SearchBarV2>

                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Créé le</TableCell>
                                        <TableCell>Statut</TableCell>
                                        <TableCell>Email</TableCell>
                                        <TableCell>Nom</TableCell>
                                        <TableCell>Prénom</TableCell>
                                        <TableCell>Role</TableCell>
                                        <TableCell>Compte</TableCell>
                                        <TableCell>Organisation</TableCell>
                                        <TableCell>Options</TableCell>
                                        
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {/* {this.getUserList()} */}
                                    {tab}
                                </TableBody>
                                {/* {size(USERS) > 10 &&
                                    <TableFooter>
                                        <TableRow>
                                            <TablePagination
                                                rowsPerPageOptions={[10, 15]}
                                                colSpan={7}
                                                count={size(USERS)}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                SelectProps={{
                                                    native: true,
                                                }}
                                                onPageChange={this.handleChangePage}
                                                onRowsPerPageChange={this.handleChangeRowsPerPage}
                                                ActionsComponent={Pagination}
                                            />
                                        </TableRow>
                                    </TableFooter>
                                } */}
                            </Table>
                        </Box>
                    }
                    {this.state.tab === 1 &&
                        <AccessList 
                            {...this.props}
                        />
                    }
                </Box>
            </div>
        
        );
    }
}

export default UsersList;